// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2epa-","top":"styles_top__1ypD9","left":"styles_left__2GgNt","description":"styles_description__25dxL"};